module.exports = {
  LIGHT_RED: '#E32321',
  DARK_RED: '#A5050D',
  PINK: '#FFDFE4',
  ORANGE: '#FF9D00',
  GREEN: '#06C755',
  SOFT_BLUE: '#0387E5',
  BLUE: '#0071C2',
  DARK_BLUE: '#0263A8',
  WHITE: '#FFFFFF',
  SOFT_WHITE: '#FBFBFB',
  LIGHT_GREY: '#EDEDED',
  LIGHT_GREY2: '#DDDDDD',
  GREY: '#B9B9B9',
  DARK_GREY: '#5A5A5A',
  DARK: '#333333',
  BLACK: '#222222',
  SUPER_BLACK: '#000000',
  SOFT_ORANGE: '#FAF4EB',
  OCEAN_BLUE: 'linear-gradient(99deg, #4F7491 2%, #0D2541 99%)',
  SKY: 'linear-gradient(to right, #22BAE3, #3880E2)',
  OCEAN: 'linear-gradient(to right, #04ADBC, #0BB2E3)',
  PINK_ROSE: 'linear-gradient(to right, #FB9EA4, #FE81A2)',
  ORANGE_GRADIENT: 'linear-gradient(to right, #F7B61B, #FF6E39)',
  RED_GRADIENT: 'linear-gradient(to right, #E32321, #A5050D 98%)',
}
